import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import CO2Icon from '@/assets/Statistics/CO2Icon';

import useCO2Deliveries from './useCO2Deliveries';

const CO2Deliveries = () => {
  const hook = useCO2Deliveries();
  return (
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 2, height: '100%' }}>
      <Typography variant="body1" sx={{ fontWeight: 600, mb: '1rem' }}>
        Contribución con el medio ambiente
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CO2Icon sx={{ fontSize: '10rem' }} />
        <Typography variant="subtitle1" color="primary" sx={{ mt: 2 }}>
          {hook.data.data?.co2EmissionSaved ?? 0} kg. de CO2
        </Typography>
        <Typography variant="body1" sx={{ mt: 1 }}>
          Ahorrados
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
          Gracias a tu contribución con
          <br />
          <strong>99minutos para tener un mejor aire </strong>
        </Typography>
      </Box>
    </Card>
  );
};

export default CO2Deliveries;
